import type { ComponentProps, ReactNode } from 'react';

import { Location } from 'react-router-dom';

import ProjectPageLayout, {
  PublicPageLayout,
  ProjectDirectoryLayout,
} from '@adsk/alloy-project-page-layout';
import { ProductIdType, ToolIdType } from '@adsk/alloy-provider';

// Routes
export const LAYOUTS = {
  PROJECT_PAGE_LAYOUT: 'projectPageLayout',
  PUBLIC_PAGE_LAYOUT: 'publicPageLayout',
  PROJECT_DIRECTORY_LAYOUT: 'projectDirectoryLayout',
  FULL_PAGE_LAYOUT: 'fullPageLayout',
} as const;

type Layouts = typeof LAYOUTS;
export type LayoutType = Layouts[keyof Layouts];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ConvertAnyToRecord<T, V = unknown> = T extends any ? Record<string, V> : T;

interface RouteBase {
  path: string;
  scope: string;
  modulePath: string;
  customTitle?: ReactNode;
  excludeSubPaths?: string[];
}

type LayoutPropsType = {
  currentToolId?: ToolIdType | 'demo-app' | '';
  currentProductId: ProductIdType | null;
  dynamicProductIdSetter?: ({
    location,
  }: {
    location: Location;
  }) => string | null;
};

export interface ToolRoute extends RouteBase {
  layout: Layouts['PROJECT_PAGE_LAYOUT'];
  layoutProps: LayoutPropsType &
    ConvertAnyToRecord<ComponentProps<typeof ProjectPageLayout>>;
}

export interface ProjectsRoute extends RouteBase {
  layout: Layouts['PROJECT_DIRECTORY_LAYOUT'];
  layoutProps?: ConvertAnyToRecord<
    ComponentProps<typeof ProjectDirectoryLayout>
  >;
}

export interface PublicRoute extends RouteBase {
  layout: Layouts['PUBLIC_PAGE_LAYOUT'];
  layoutProps?: ConvertAnyToRecord<ComponentProps<typeof PublicPageLayout>>;
  customTitle: RouteBase['customTitle'];
}

export interface FullPageRoute extends RouteBase {
  layout: Layouts['FULL_PAGE_LAYOUT'];
}

export type Route = ToolRoute | ProjectsRoute | PublicRoute | FullPageRoute;
